// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__5dO_D","fileBtn":"File_fileBtn__1ndwW","closeBtn":"File_closeBtn__YGOhg","fileSelected":"File_fileSelected__2PNyI","disabled":"File_disabled__1Bvte"};